import { v4 as uuidv4 } from "uuid";
import API_URL from "./api-urls";
import { shouldSkipClientAjaxForBot } from "@packages/lib/utlils/bot-detection";

const promiseCache = new Map();

interface FetchOptions {
  url: string;
  method: "GET" | "POST";
  queryParams?: Record<string, string | number>;
  body?: Record<string, any> | null;
  headers?: Record<string, string>;
  useCache?: boolean;
}

export async function makeApiCall({
  url,
  method = "GET",
  queryParams = {},
  body = null,
  headers = {},
  useCache = false,
}: FetchOptions): Promise<any> {
  if (Object.keys(queryParams).length > 0) {
    const queryString = new URLSearchParams(queryParams as any).toString();
    url += `?${queryString}`;
  }

  if (shouldSkipClientAjaxForBot(url)) {
    return {};
  }

  const cacheKey = JSON.stringify({ url, body });

  if (useCache && promiseCache.has(cacheKey)) {
    return await promiseCache.get(cacheKey);
  }
  console.log({ url });
  try {
    const fetchOptions: RequestInit = {
      method,
      headers: {
        "Content-Type": "application/json",
        "x-correlation-id": uuidv4(),
        sitecode: `${process.env.SITE_CODE}`,
        ...headers,
      },
    };
    if (method.toUpperCase() !== "GET" && body) {
      fetchOptions.body = JSON.stringify(body);
    }

    const promise = (async () => {
      const response: any = await fetch(url, fetchOptions);

      if (!response.ok) {
        const now = new Date();
        const date = now.toISOString().split("T")[0];
        const time = now.toTimeString().split(" ")[0];

        if (process.env.NEXT_PUBLIC_ENVIRONMENT != "local") {
          await fetch(
            `${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}${API_URL?.logErrors}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-correlation-id": uuidv4(),
                "x-api-key": `${process.env.NEXT_PUBLIC_X_API_KEY}`,
                sitecode: `${process.env.SITE_CODE}`,
              },
              body: JSON.stringify({
                type: "API Errors",
                date,
                time,
                errorMessage: response?.message,
                errorStatus: response?.status,
                projectName: process.env.PROJECT,
                environment: process.env.ENVIRONMENT,
                affiliateId: process.env.AFFILATE_ID,
                sitecode: process.env.SITE_CODE,
                apiDetails: { url, method, body, headers, queryParams },
              }),
            },
          );
        }
        return;
      }

      return await response.json();
    })();

    if (useCache) {
      promiseCache.set(cacheKey, promise);
    }

    return await promise;
  } catch (error) {
    if (useCache) {
      promiseCache.delete(cacheKey);
    }
    console.error("Error fetching data:", error);
    throw error;
  }
}

export default makeApiCall;
